import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpService } from '../http.service';
import { HttpRequestHandler } from '../../models/http-model';



const HEADERS = {};

@Injectable()
export class ProcessExtractionService {
  static ENV = environment;
  constructor(private httpService: HttpService) { }

  public getDataEntitiesDOEQ(httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.get(ProcessExtractionService.ENV.environment.API.get_legal_entity_DOEQ, httpRequesthandler);
  }

  public getDataLedgerDOEQByEntity(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.post(ProcessExtractionService.ENV.environment.API.get_ledger_DOEQ, data, httpRequesthandler);
  }

  public getDataProviderDOEQ(httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.get(ProcessExtractionService.ENV.environment.API.get_providers_DOEQ, httpRequesthandler);
  }

}



// WEBPACK FOOTER //
// ./src/app/core/services/process-extraction/process-extraction.service.ts